import React from 'react';
import { Alert } from 'reactstrap';

import useAppContext from 'utils/hooks/useAppContext';

export default function OnlineCheck() {
  const { isOnline } = useAppContext();

  if (isOnline) return null;

  return (
    <Alert color="danger" id="fixedOnlineAlert" className="fadeInUp">
      No internet connection. Try again when you are online.
    </Alert>
  );
}
